import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  AddSalesPointOpts,
  AppAuthService,
  MunicipalEntitiesService,
  SalesPointsService,
  AddressSuggesterService,
  UsersService,
} from '@prodcard/core'
import SalesPointsForm from './SalesPointsForm.vue'
import { CardHeader } from '../../../../components'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesPointsNewPage',
  props: {
    authService: {},
    salesPointsService: {},
    municipalEntitiesService: {},
    usersService: {},
    addressSuggesterService: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()
const loading = ref(false)

const submit = (opts: AddSalesPointOpts) => {
  handleError(async () => {
    await props.salesPointsService.add(createCtx(), opts)
    callSuccessToast('Торговый объект создан')
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            title: _withCtx(() => [
              _createTextVNode(" Новый торговый объект ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(SalesPointsForm, {
            "auth-service": _ctx.authService,
            "municipal-entities-service": _ctx.municipalEntitiesService,
            "users-service": _ctx.usersService,
            "address-suggester-service": _ctx.addressSuggesterService,
            loading: loading.value,
            onSubmit: submit
          }, null, 8, ["auth-service", "municipal-entities-service", "users-service", "address-suggester-service", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})